import { AssignedDealer } from './dealer';
import { GeoCoordinates } from './geography';
import { ContactPerson, CustomNote, ReverseGeoCoding } from './subscriber';
import { UnitDependent } from './unit';

export type IPLinkServiceLog = {
  address1?: string;
  address2?: string;
  buId?: number;
  city?: string;
  eventLabel?: string;
  modelNumber?: string;
  modelRev?: string;
  state?: string;
  status?: string;
  unitId?: number;
  zipCode?: string;
};

export type IPLink = GeoCoordinates &
  IPLinkServiceLog & {
    id: number;
    businessUnitId: number;
    businessUnitName: string;
    connectCount: number;
    connectionInterval: number;
    faultCount: number;
    packetCount: number;
    ppPacketCount: number;
    numbOfDependantSubscribers: number;
    supervisionIntervalSecs: number;
    isOffline: boolean;
    dependentCalculationTime?: number;
    dependentDay: IPLink['id'][];
    dependentDayCount: number;
    dependentDecade: IPLink['id'][];
    dependentDecadeCount: number;
    dependencies: UnitDependent[];
    /** First connection  */
    firstConnectionTime: number;
    /** Last connection */
    lastConnectionTime: number;
    /** Last Packet */
    lastUpdate: number;
    model?: string;
    address1?: string;
    address2?: string;
    antenna?: string;
    city?: string;
    compassNumber?: number;
    connectInterval?: number;
    country?: string;
    customer?: string;
    dealerId?: number;
    dealerName?: string;
    note?: string;
    revision?: string;
    stateOrProvince?: string;
    zipOrPostalCode?: string;
    eventHistory?: IPLinkHistory[];
    notifications?: IPLinkNotifications;
    dealers?: AssignedDealer[];
    customNotes?: CustomNote[];
    reverseGeoCoding?: ReverseGeoCoding;
    contactPersons?: ContactPerson[];
  };

export type IPLinksListSection = 'all' | 'service-log';

export enum IPLinksLocation {
  IpLinks,
  BusinessUnits,
}

export type IPLinkHistory = {
  alarmTime: number;
  businessUnitId: number;
  eventCode: string;
  eventName: string;
  ipLinkId: number;
};

export type IPLinkHistoryPeriod = 'TEN_DAYS' | 'MONTH';

export type IPLinkNotifications = {
  emails: string[],
  sendRestoral: boolean,
  sendNotification: boolean,
  allEvents:
    {
      eventName: string,
      eventLabel: string,
      faultCode: string
    }[],
  events:
    {
      event: string,
      isEnable: boolean
    }[],
    mobileInfo:
    {
      phoneNumber: string | null
    }[] | null
};
